const strings = {
  'roles/img/hockeyChallengeLogo/alt': {
    en: 'Hockey Challenge Logo',
    fr: 'Logo du Défi de hockey',
  },
  'roles/button/close/aria': {
    en: 'Close',
    fr: 'Fermer',
  },
};

export default strings;
